var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("div", { staticClass: "newBg" }, [
        _c(
          "div",
          { staticClass: "vanTabs" },
          [
            _c(
              "van-tabs",
              {
                attrs: {
                  ellipsis: "",
                  "line-width": _vm.lineWidth,
                  border: ""
                },
                on: {
                  change: function() {
                    return _vm.changeTabs()
                  }
                },
                model: {
                  value: _vm.active,
                  callback: function($$v) {
                    _vm.active = $$v
                  },
                  expression: "active"
                }
              },
              _vm._l(_vm.tabArray, function(tab, index) {
                return _c("van-tab", { key: index, attrs: { title: tab } }, [
                  _c(
                    "div",
                    { staticClass: "padding20X paddingX14 van-bgcolor-white" },
                    [
                      index === 0
                        ? [
                            _c(
                              "div",
                              [
                                _c("brc20Tab", {
                                  ref: "brc20TabRef",
                                  refInFor: true,
                                  on: {
                                    showAdPopUp: _vm.showAdPopUp,
                                    showTransferPopUpBrc20:
                                      _vm.showTransferPopUpBrc20
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      index === 1
                        ? [
                            _c(
                              "div",
                              { staticClass: "tab2" },
                              [
                                _c("artTab", {
                                  ref: "artTabRef",
                                  refInFor: true
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      index === 2
                        ? [
                            _c(
                              "div",
                              { staticClass: "tab2" },
                              [
                                _c("artTab", {
                                  ref: "artTabRef",
                                  refInFor: true
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      index === 3
                        ? [
                            _c(
                              "div",
                              [
                                _c("dmtTab", {
                                  ref: "dmtTabRef",
                                  refInFor: true,
                                  on: {
                                    showAdPopUp: _vm.showAdPopUp,
                                    showTransferPopUp: _vm.showTransferPopUp
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : index === 4
                        ? [
                            _c(
                              "div",
                              { staticClass: "tab2" },
                              [
                                _c("artTab", {
                                  ref: "artTabRef",
                                  refInFor: true
                                })
                              ],
                              1
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ])
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShowBtn,
                expression: "isShowBtn"
              }
            ]
          },
          [
            _vm.active != 4
              ? _c("div", { staticClass: "footerBtns" }, [
                  _c(
                    "div",
                    {
                      staticClass: "cancel",
                      on: {
                        click: function($event) {
                          return _vm.goAppBack()
                        }
                      }
                    },
                    [_c("van-button", [_vm._v(_vm._s(_vm.$t("300111")))])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "next" },
                    [
                      _c(
                        "van-button",
                        {
                          attrs: { "native-type": "submit", color: "#000" },
                          on: {
                            click: function($event) {
                              return _vm.next()
                            }
                          }
                        },
                        [_vm._v("下一步")]
                      )
                    ],
                    1
                  )
                ])
              : _c("div", { staticClass: "footerBtns" }, [
                  _c(
                    "div",
                    { staticClass: "cancel" },
                    [_c("van-button", [_vm._v(_vm._s(_vm.$t("300111")))])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "nextTab2" },
                    [
                      _c("van-button", { attrs: { disabled: "" } }, [
                        _vm._v("下一步")
                      ])
                    ],
                    1
                  )
                ])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "cu-popup",
        {
          ref: "selectAdRef",
          attrs: {
            styleObj: { minHeight: "30%", maxHeight: "80%" },
            title: "接收地址"
          },
          on: {
            confirm: function($event) {
              return _vm.changeAd()
            },
            close: function($event) {
              return _vm.clearCurtSelect()
            }
          }
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c(
              "div",
              { staticClass: "my-ad" },
              [
                _c("span", { staticClass: "my-ad-text" }, [_vm._v("我的地址")]),
                _vm._v(" "),
                _c(
                  "van-cell-group",
                  _vm._l(_vm.myAds, function(item, index) {
                    return _c(
                      "van-cell",
                      {
                        key: index,
                        attrs: { title: item.ad },
                        on: {
                          click: function($event) {
                            return _vm.handleSelect(item.ad)
                          }
                        }
                      },
                      [
                        _vm.currentSelectVal === item.ad
                          ? _c("van-icon", {
                              attrs: { slot: "right-icon", name: "success" },
                              slot: "right-icon"
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "lately-record" },
              [
                _c("span", { staticClass: "lately-record-text" }, [
                  _vm._v("\n                    最近记录\n                ")
                ]),
                _vm._v(" "),
                _c(
                  "van-cell-group",
                  _vm._l(_vm.getRd, function(item, index) {
                    return _c(
                      "van-cell",
                      {
                        key: index,
                        staticClass: "rd-cell",
                        attrs: { title: item },
                        on: {
                          click: function($event) {
                            return _vm.handleSelect(item)
                          }
                        }
                      },
                      [
                        _vm.currentSelectVal === item
                          ? _c("van-icon", {
                              attrs: { slot: "right-icon", name: "success" },
                              slot: "right-icon"
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "cu-popup",
        {
          ref: "selectCyRef",
          attrs: {
            styleObj: { minHeight: "30%", maxHeight: "80%" },
            title: _vm.getTransferTitle
          },
          on: {
            confirm: function($event) {
              return _vm.changeCy()
            },
            close: function($event) {
              return _vm.clearCurtSelect()
            }
          }
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c(
                "van-cell-group",
                _vm._l(_vm.transferList, function(item, index) {
                  return _c(
                    "van-cell",
                    {
                      key: index,
                      class: [
                        { "select-cy-active": _vm.currentSelectVal === item },
                        "select-cy"
                      ],
                      attrs: { title: item },
                      on: {
                        click: function($event) {
                          return _vm.handleSelect(item)
                        }
                      }
                    },
                    [
                      _vm.currentSelectVal === item
                        ? _c("van-icon", {
                            attrs: { slot: "right-icon", name: "success" },
                            slot: "right-icon"
                          })
                        : _vm._e()
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "cu-popup",
        {
          ref: "selectCyRefBrc20",
          attrs: {
            styleObj: { minHeight: "30%", maxHeight: "80%" },
            title: _vm.getTransferTitle
          },
          on: {
            confirm: function($event) {
              return _vm.changeCyBrc20()
            },
            close: function($event) {
              return _vm.clearCurtSelect()
            }
          }
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c(
                "van-cell-group",
                _vm._l(_vm.Brc20TransferList, function(item, index) {
                  return _c(
                    "van-cell",
                    {
                      key: index,
                      class: [
                        { "select-cy-active": _vm.currentSelectVal === item },
                        "select-cy"
                      ],
                      attrs: { title: item },
                      on: {
                        click: function($event) {
                          return _vm.handleSelect(item)
                        }
                      }
                    },
                    [
                      _vm.currentSelectVal === item
                        ? _c("van-icon", {
                            attrs: { slot: "right-icon", name: "success" },
                            slot: "right-icon"
                          })
                        : _vm._e()
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05b40c7d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05b40c7d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/InscriptionArea/Inscription.vue
// module id = la0Y
// module chunks = 0